export default __webpack_public_path__ + "static/media/banner_fliped.a356e07f.jpg";